import { NormalIconProps } from 'assets/icons';
import React from 'react';

export const TimerIcon: React.FC<NormalIconProps> = (props) => (
	<svg viewBox="0 0 24 24" className={props.className} fill="none" xmlns="http://www.w3.org/2000/svg">
		<rect width="24" height="24" rx="4" fill="none" />
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M18.1666 12.0002C18.1666 15.4062 15.4059 18.1668 11.9999 18.1668C8.59392 18.1668 5.83325 15.4062 5.83325 12.0002C5.83325 8.59416 8.59392 5.8335 11.9999 5.8335C15.4059 5.8335 18.1666 8.59416 18.1666 12.0002Z"
			stroke="#003F41"
			strokeWidth="1.2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path d="M14.2877 13.9616L11.7744 12.4623V9.23096" stroke="#003F41" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
	</svg>
);
